import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #c9cfd3;
`
const st1 = css`
  fill: #ffffff;
`
const st2 = css`
  fill: #273e4f;
`

class ViewDocuments extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path
          css={st0}
          d='M73.8,12V6l8.1,8.2H76C74.8,14.2,73.8,13.2,73.8,12z'
        />
        <path
          css={st1}
          d='M84.9,15.4v79.7c0,1.3-1,2.3-2.3,2.3H17.4c-1.3,0-2.3-1-2.3-2.3V13c0-1.3,1-2.3,2.3-2.3h5.9V4.9 c0-1.3,1-2.3,2.3-2.3l47.3,0c0,0-2.2,8.7,1.4,12.1C76.6,17,84.9,15.4,84.9,15.4z'
        />
        <path
          css={st2}
          d='M87.7,15.9c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1 c0-0.1-0.1-0.1-0.2-0.2c0,0,0,0-0.1-0.1l0,0l0,0l-14-14.2c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0-0.1,0 c-0.1,0-0.2-0.1-0.2-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2-0.1c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0H26c-3.2,0-5.8,2.6-5.8,5.8V8H18 c-3.2,0-5.8,2.6-5.8,5.8v80.5c0,3.2,2.6,5.8,5.8,5.8h64c3.2,0,5.8-2.6,5.8-5.8L87.7,15.9C87.8,16,87.7,15.9,87.7,15.9z M18,96.5 c-1.2,0-2.2-1-2.2-2.2V13.8c0-1.2,1-2.2,2.2-2.2h2.2v82.8c0,0.8,0.2,1.6,0.5,2.2H18z M73.8,6l8.1,8.2H76c-1.2,0-2.2-1-2.2-2.2V6z M84.2,94.2c0,1.2-1,2.2-2.2,2.2H26c-1.2,0-2.2-1-2.2-2.2V5.8c0-1.2,1-2.2,2.2-2.2h44.2V12c0,3.2,2.6,5.8,5.8,5.8h8.2V94.2z M30.8,18h28.4c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8H30.8c-1,0-1.8,0.8-1.8,1.8S29.8,18,30.8,18z M29,24.2c0,1,0.8,1.8,1.8,1.8 h46.5c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8H30.8C29.8,22.5,29,23.2,29,24.2z M77.2,30.5H30.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8 h46.5c1,0,1.8-0.8,1.8-1.8S78.2,30.5,77.2,30.5z M77.2,38.5H30.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h46.5c1,0,1.8-0.8,1.8-1.8 S78.2,38.5,77.2,38.5z M77.2,46.5H30.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h46.5c1,0,1.8-0.8,1.8-1.8S78.2,46.5,77.2,46.5z M77.2,54.5H30.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h46.5c1,0,1.8-0.8,1.8-1.8S78.2,54.5,77.2,54.5z M77.2,62.5H30.8 c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h46.5c1,0,1.8-0.8,1.8-1.8S78.2,62.5,77.2,62.5z M77.2,70.5H30.8c-1,0-1.8,0.8-1.8,1.8 s0.8,1.8,1.8,1.8h46.5c1,0,1.8-0.8,1.8-1.8S78.2,70.5,77.2,70.5z M46.9,78.5H30.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h16.1 c1,0,1.8-0.8,1.8-1.8S47.8,78.5,46.9,78.5z'
        />
      </svg>
    )
  }
}

ViewDocuments.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { ViewDocuments }
